module.exports = __webpack_public_path__ + "static/media/logo.1f9fcaf7.svg";